//header
let header = document.querySelector(".js-header"),
  heroIs = document.getElementsByClassName("o-hero"),
  mainContent = document.querySelector(".l-main");

if (heroIs.length) {
  header.classList.add("is-hero");
  mainContent.classList.add("is-hero");
}

let scrEv = () => {
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop;

  if (scrollTop > 50) {
    header.classList.add("is-scroll");
    header.classList.remove("is-hero");
  } else if (heroIs.length) {
    header.classList.add("is-hero");
    header.classList.remove("is-scroll");
  } else {
    header.classList.remove("is-scroll");
  }
};

document.addEventListener("scroll", scrEv, { passive: true });

scrEv();
